export default __webpack_public_path__ + "static/media/gugu.4044d6ec.jpg";